import { useState } from "react";
//------------------------------------------
import UserInfoModal from "src/components/common/userInfoModal";
import userimg from "src/img/user.png";
import { json } from "src/components/common/types";
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, 
    MyFormData, 
} from "src/components/common/functions";
//------------------------------------------
export default function UserInfo(
    {
        name, 
        email, 
        id, 
    }:{
        name: string, 
        email: string, 
        id: string, 
    }
){
    //------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [showUserInfo, setShowUserInfo] = useState(false);
    const [u, setU] = useState({});
    //------------------------------------------
    const closeIt = () => {
        setShowUserInfo(false);
    }
    //------------------------------------------
    return(
        <>
            <button
                type = "button"
                className = "headerButton noborder"
                id = {id}
                style = {{
                    color: "blue", 
                    cursor: "pointer"
                }}
                onClick = {async () => {
                    const formData = new MyFormData();
                    formData.append("uEmail", email);
                    //-------------------------------------------------------------
                    setShowLoader(true);
                    const res: false | json = await myAxios("common/readUserInfo.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //-------------------------------------------------------------
                    if(res.data.thumbnail){
                        setU(res.data);
                    }else{
                        setU({
                            ...res.data, 
                            thumbnail: userimg
                        });
                    }
                    setShowUserInfo(true);
                }}
            >
                {name}
            </button>
            {showUserInfo?
            <UserInfoModal
                user = {u}
                closeIt = {closeIt} 
            />:null}
        </>
    )
}